var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import { useFlyoutContext } from "./Flyout.context.js";
import styles from "@bookingcom/bui-core/css/_base/Flyout.module.css";
var FlyoutArrow = function (props) {
    var _a = useFlyoutContext(), flyout = _a.flyout, flyoutArrowElRef = _a.flyoutArrowElRef;
    var position = flyout.position;
    var className = props.className, offset = props.offset, size = props.size, background = props.background, shadow = props.shadow;
    var arrowClassName = classNames(styles.arrow, position && styles["arrow--position-".concat(position)], className);
    var arrowStyles = __assign({ "--bui-flyout-arrow-offset": "var(--bui_spacing_".concat(offset, "x)"), "--bui-flyout-arrow-size": "".concat(size, "px"), "--bui-flyout-arrow-background": "var(--bui_color_background_".concat(background, ")") }, (shadow
        ? {
            "--bui-flyout-arrow-shadow": "var(--bui_shadow_".concat(shadow, ")"),
        }
        : {}));
    return (React.createElement("span", { className: arrowClassName, style: arrowStyles },
        React.createElement("span", { ref: flyoutArrowElRef }),
        React.createElement("span", null)));
};
export default FlyoutArrow;
